
import { Component, Vue } from 'vue-property-decorator'
import AppButton from '@/components/AppButton.vue'
import { ChildComponentMixin } from '@/mixins'

@Component({
    components: {
        AppButton,
    },
})
export default class HomeHeader extends ChildComponentMixin {
    private addAppClick() {
        this.$router.push('/app/update/new')
    }
}
